import { UseQueryOptions } from '@tanstack/react-query'
import {
  FetcherError as TError,
  GetMembersDownloadsQuery as TData,
  GetMembersDownloadsQueryVariables as TVars,
  useGetMembersDownloadsQuery as useEndpoint,
} from '../types'

type TOptions = UseQueryOptions<TData, TError, TData>

const getKey = useEndpoint.getKey

function useGetMembersDownloads(variables: TVars, options?: TOptions) {
  const query = useEndpoint(variables, {
    ...options,
  })
  return query
}

export type { TVars }
export { getKey }
export default useGetMembersDownloads
